export default "__VITE_ASSET__cypr9sRJ__"